import '../../../styles/Alert.css';
import React from 'react';
import {Notification, toaster} from "@appkit4/react-components/notification"

const displayToastMessage = (message, type) => {
	const ele = (
		<Notification
		status={type}
		message={message}
		closeable={false}
		className='a-popup-alert alert-popup-top appkit-animation animated bounceIn'
		/>
	)
	return (
		toaster.notify(ele, {
			position: "topRight",
			duration: 5000
		})
	)
}

export default displayToastMessage;